// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__2CoX6","mob":"style_mob__3-Ty5","innerWrapper":"style_innerWrapper__HvHux","arrowIcon":"style_arrowIcon__8z3xP","btn":"style_btn__2PV1S"};